module.exports = __webpack_public_path__ + "static/media/ai_new_chat.4161c8b1.svg";